module.exports = {"id":"199151","name":"Juan Manuel Iturbe","rating":"76","photo":"./data/images/photos/4/199151.png","club":{"name":"Tijuana","logo":"./data/images/clubs/Tijuana.png"},"positions":["AD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JuanManuelIturbe0.json
// module id = 2216
// module chunks = 0